import { TbX } from "solid-icons/tb";
import { type Component, Show } from "solid-js";
import { StButton } from "@core/components/_original/StButton";

export const LandingPageNavbarBanner: Component<{ show: boolean; onClose: () => void }> = (props) => {
  return (
    <Show when={props.show}>
      <div class="bg-indigo-800 text-white relative">
        <div class="mx-auto max-w-screen-xl px-10 py-3 text-base leading-normal text-center">
          Bring the power of Storytell to every website! Get Our Chrome Extension.{" "}
          <a
            href="https://go.storytell.ai/chrome"
            target="_blank"
            rel="noreferrer"
            class="underline underline-offset-2"
          >
            Install it here.
          </a>
        </div>

        <StButton
          label="Close"
          simple
          class="min-w-max min-h-max absolute right-2 top-2 text-white hover:bg-white/20"
          icon={TbX}
          onClick={props.onClose}
        />
      </div>
    </Show>
  );
};
